export const FAVORITES_LOADING = 'FAVORITES_LOADING';
export const SAVE_FAVORITES = 'SAVE_FAVORITES';
export const TOGGLE_FAVORITES = 'TOGGLE_FAVORITES';